'use strict';

const BaseStore = require('fluxible/addons/BaseStore');
const Qs = require('qs');
const result = require('lodash.result');
const pick = require('lodash.pick');
const tracking = require('dibs-tracking');

const yesNo = predicate => predicate ? 'y' : 'n';
const SV = require('server-vars');

class ContactGaStore extends BaseStore {

    constructor(dispatcher) {
        super(dispatcher);
        this._reset();
    }

    initialLoad({linkLocation}) {
        this.data.linkLocation = linkLocation;
    }

    constructVpvParams({ item, seller }) {
        this.data.vpvParams = {
            dd: seller.get('id'),
            dn: seller.get('sellerProfile.company')
        };
        this.data.purchaseStatus = '';
        if (item) {
            this.data.item = item;
            this.data.isItem = true;
            let hasPreQuoteShipping = false;
            if (item.get('shipmentQuotes')) {
                hasPreQuoteShipping = item.get('shipmentQuotes').getNonLocalShipmentQuotes().length;
            }
            Object.assign(this.data.vpvParams, {
                id: item.get('id'),
                status: this._getStatus(item),
                pur: yesNo(item.canMakePurchase()),
                neg: yesNo(item.isNegotiablePrice()),
                ship: yesNo(hasPreQuoteShipping),
                ret: yesNo(result(item.get('returnPolicy'), 'acceptsReturns'))
            });
            this.data.purchaseStatus = Qs.stringify(pick(this.data.vpvParams, 'neg', 'ship', 'ret'), {
                delimiter: '|'
            });
        }
        this.data.vpvParamsQuery = decodeURIComponent(Qs.stringify(this.data.vpvParams).toLowerCase());
    }

    _getStatus(item) {
        const seller = item.get('seller');
        let status = 'Available-Price';
        if (seller.isStatusSuspended() || item.isItemDeleted()) {
            status = 'Suspended';
        } else if (item.isOnHold()) {
            status = 'Hold';
        } else if (item.isSold()) {
            status = 'Sold';
        } else if (item.hidingPrice()) {
            status = 'Available-No Price';
        }
        return `PDP-${status}`;
    }

    _reset() {
        this.data = {};
    }

    resetPage() {
        return tracking.addGTMMessage({
            pageType: SV.get('tracking.initialDataLayerInfo.pageType'),
            pageSubType: SV.get('tracking.initialDataLayerInfo.pageSubType')
        });
    }
}

ContactGaStore.storeName = 'ContactGaStore';
ContactGaStore.handlers = {
    'contact:loading:start': 'initialLoad',
    'contact:loading:done': 'constructVpvParams',
    'contact:modal:close': 'resetPage'
};

module.exports = ContactGaStore;



// WEBPACK FOOTER //
// ./assets/js/contact/shared/stores/ContactGaStore.es.js